// import Notify from './libs/notify'
import {Notify} from "vant";

const axios = require('axios')
import Vue from 'vue';

let vue = new Vue;

const instance = axios.create({
  baseURL: process.env.VUE_APP_API
})
instance.interceptors.request.use(
  config => {
    let token=sessionStorage.getItem('token')
    // console.log(token,'token拦截器的')
    if(token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
instance.defaults.validateStatus = status => {
  return status === 200 || status === 500 || status === 403
}
instance.interceptors.response.use(res => {
    if (res.status !== 200 || (res.data && res.data.code > 0 && res.data.code !== 200)) {
      // let msg = '请求出错'
      console.log(res.status,'res.status')
      if (res.data.message) {
        vue.$notify({ type: 'warning', message: res.data.message });
        // vue.$Message.error(res.data.message)
      }
      return Promise.reject(res.data.message);
      throw new Error(res.data.message)
    } else {
      if(res.status === 403){
        // vue.$router.push('/login')
      }else {
        return res
      }
    }
  },
  error=>{
    console.log(error,'errorerrorhttp.js')
    vue.$notify('服务器有点忙喔~~');
    return Promise.reject('服务器有点忙喔~~');
  }
)

export default instance
